module.exports = __webpack_public_path__ + "static/img/30012 (1).ee68ee4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30012 (1).webp
// module id = CoAD
// module chunks = 14